<div class="marker-project-info" [ngClass]="displayClass">
  <div class="d-flex">
    <div *ngIf="!alwaysDisplay" class="clickable" (click)="hide()">
      <mat-icon class="scale-icon">keyboard_backspace</mat-icon>
    </div>
    <div
      class="marker-project-title clickable"
      [routerLink]="['/project', subProject.project.id, subProject.id]"
    >
      #{{ subProject.project.id }}
    </div>
    <div *ngIf="involvedCompanies?.length > 0" class="d-flex">
      <div class="marker-project-title smaller-left-space">-</div>
      <div>
        <div
          *ngFor="let company of involvedCompanies"
          class="marker-project-title smaller-left-space"
        >
          {{ company }}
        </div>
      </div>
    </div>
  </div>
  <div class="strong smaller-upper-space">
    {{
      subProject.project.baseProjectAddress.line1
        | printAddress
          : subProject.project.baseProjectAddress.postalCode
          : subProject.project.baseProjectAddress.city
    }}
  </div>
  <div class="smaller-upper-space d-flex">
    <div class="strong">
      {{
        subProject.type
          | overviewProjectType: subProject.status:subProject.withPlacement
      }}
    </div>
    <div *ngIf="subProject.project.products?.length" class="d-flex">
      <div class="strong smaller-left-space">-</div>
      <div>
        <div
          *ngFor="let product of subProject.project.products"
          class="strong smaller-left-space"
        >
          {{
            product.type
              | productType: product.otherProductName:product.overviewFormat
              | joiner: ' - ':product.boardType:product.placementType
          }}
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div>
    <span *ngIf="subProject.currentRequestASAP; else currentRequestDate">
      Gewenste plaatsingsdatum: ASAP
    </span>
    <ng-template #currentRequestDate>
      Gewenste plaatsingsdatum:
      <span class="secondary-color strong">{{
        subProject.currentRequestDate | formatDate: '-'
      }}</span>
    </ng-template>
  </div>
  <div class="smaller-upper-space">Voorziene werktijd: {{ timeBudget }}</div>
  <hr />
  <ng-container *ngIf="showSubmitPlanContent">
    <div class="d-flex">
      <div>
        <div class="form-sub-title">
          Datum {{ subProject.type === 'Repo' ? 'weghalen' : 'plaatsing' }}
        </div>
        <mat-form-field appearance="outline">
          <input
            #confirmedPlacementDateInput
            matInput
            [matDatepicker]="placementDatePicker"
            placeholder="Selecteer een datum"
            [value]="selectedPlacementDate"
            name="confirmedPlacementDateDate"
            (dateChange)="selectedPlacementDateChanged($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="placementDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #placementDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="left-space">
        <div class="form-sub-title">Installateur(s)</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            multiple
            placeholder="Maak een keuze"
            required
            [(ngModel)]="selectedPlacers"
            name="placer"
            (ngModelChange)="placerChange()"
            [compareWith]="compareEntities"
          >
            <mat-option *ngFor="let option of placerOptions" [value]="option">
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="selectedPlacerNames?.length > 0" class="under-space">
      Gekozen installateurs: {{ selectedPlacerNames }}
    </div>
    <div *ngIf="submitting" style="align-self: center;">
      <mat-spinner
        style="margin: auto;"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </div>
    <div *ngIf="!submitting" class="plan-button-container">
      <button
        type="button"
        class="plan-button"
        mat-button
        (click)="planSubProject()"
      >
        Inplannen
      </button>
    </div>
  </ng-container>
</div>
